module.exports = __webpack_public_path__ + "static/media/thanks.1121f463.png";